export const difficultyLevels = {
  activities: [
    {
      value: 'LEVEL_1',
      text: 'very_easy'
    },
    {
      value: 'LEVEL_2',
      text: 'easy'
    },
    {
      value: 'LEVEL_3',
      text: 'moderate'
    },
    {
      value: 'LEVEL_4',
      text: 'challenging'
    },
    {
      value: 'LEVEL_5',
      text: 'difficult'
    }
  ],
  experiences: [
    {
      value: 'LEVEL_1',
      text: 'very_easy'
    },
    {
      value: 'LEVEL_2',
      text: 'easy'
    },
    {
      value: 'LEVEL_3',
      text: 'moderate'
    },
    {
      value: 'LEVEL_4',
      text: 'challenging'
    },
    {
      value: 'LEVEL_5',
      text: 'difficult'
    }
  ],
  tours: [
    {
      value: 'LEVEL_1',
      text: 'very_easy'
    },
    {
      value: 'LEVEL_2',
      text: 'easy'
    },
    {
      value: 'LEVEL_3',
      text: 'moderate'
    },
    {
      value: 'LEVEL_4',
      text: 'challenging'
    },
    {
      value: 'LEVEL_5',
      text: 'difficult'
    }
  ],
  users: [
    {
      value: 'LEVEL_1',
      text: 'beginner'
    },
    {
      value: 'LEVEL_2',
      text: 'basic'
    },
    {
      value: 'LEVEL_3',
      text: 'intermediate'
    },
    {
      value: 'LEVEL_4',
      text: 'advanced'
    },
    {
      value: 'LEVEL_5',
      text: 'expert'
    }
  ],
}